module.exports = __webpack_public_path__ + "files/9f4f52a856e3573f37fbf8509eae23e8.png";